import { render, staticRenderFns } from "./MediaCardComponent.vue?vue&type=template&id=bbab888c"
import script from "./MediaCardComponent.vue?vue&type=script&lang=js"
export * from "./MediaCardComponent.vue?vue&type=script&lang=js"
import style0 from "./MediaCardComponent.vue?vue&type=style&index=0&id=bbab888c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports